import { reqCyRecommendation, reqCyQueryAdvert } from 'changyo-public-api'
import cookie from 'js-cookie'
import Hammer from 'hammerjs'
import { server } from '../../assets/config/env'

export default {
  name: 'HjfNotice',

  props: {
    isApiDataLoaded: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      $scrollEl: null,
      banner: '',
      banner2: '',
      notice: '',
      count: 5,
      displayCyliveBanner: false,
      // displayFullBanner: false,
      fullBannerMinY: -window.innerHeight,
      fullBannerMaxY: 0,
      firstScroll: true,
      liveUrl: cookie.get('CHANGYOU_LIVE_BANNER_URL'),
      dis: 0,
      displayWinMask: true,
      displayBtnForClosing: false
    }
  },

  mounted() {
    if (!this.liveUrl) {
      cookie.remove('CHANGYOU_LIVE_BANNER_URL')
    }

    this.$scrollEl = document.querySelector('.homepage')

    // this._initBanner()
    this._initBanner2()
  },

  methods: {
    _initInteraction() {
      window.ontouchstart = e => {

        if (this.timerGo) {
          clearTimeout(this.timerGo)
        }

        const pos = e.targetTouches[0]

        this.startY = pos.pageY
        this.curBannerPos = this.$refs.$fullBanner.curPos
        this.curGrowSize = this.$refs.$space.size
        this.top = this.$scrollEl.scrollTop === 0

        if (this.curBannerPos === this.fullBannerMaxY) {
          this.$scrollEl.style.overflow = 'hidden'
        } else {
          this.$scrollEl.style.overflow = 'auto'
        }
      }

      this.$scrollEl.ontouchmove = e => {
        if (this.top) {
          const pos = e.targetTouches[0]
          const dis = pos.pageY - this.startY

          // 解决 oppo 华为兼容问题
          if (dis > 0) {
            e.preventDefault()
          }

          this._scrollFullBannerY(this.$refs.$fullBanner, this.curBannerPos + dis)
          this._grow(this.$refs.$space, this.curGrowSize + dis)
          this.ratio = this.$refs.$space.size / (this.fullBannerMaxY - this.fullBannerMinY) * 100
          this.posY = dis > 0 ? 1 : -1

          if (this.ratio > 30) {
            this.$refs.$tip.innerHTML = '释放进入上一楼'
          } else if (this.ratio > 20) {
            this.$refs.$tip.innerHTML = '继续下拉进入上一楼'
          } else {
            this.$refs.$tip.innerHTML = ''
          }
        }
      }

      window.ontouchend = e => {
        let bannerY = 0
        let spaceY = 0

        if (this.posY === -1) {

          // 向上
          if (100 - this.ratio > 30) {

            // 收起
            bannerY = this.fullBannerMinY
            spaceY = this.fullBannerMaxY
          } else {

            // 展开
            bannerY = this.fullBannerMaxY
            spaceY = -this.fullBannerMinY
          }
        } else {

          // 向下
          if (this.ratio > 30) {

            // 展开
            bannerY = this.fullBannerMaxY
            spaceY = -this.fullBannerMinY

            // 1 秒后进入直播间
            this.timerGo = setTimeout(() => {
              if (this.liveUrl.match('cylive')) {
                window.spm.push([ '_trackEvent', '101589', '02', '200' ])
              }

              location.href = this.liveUrl
            }, 1500)
          } else {

            // 收起
            bannerY = this.fullBannerMinY
            spaceY = this.fullBannerMaxY
          }
        }

        this._scrollFullBannerY(this.$refs.$fullBanner, bannerY, true)
        this._grow(this.$refs.$space, spaceY, true)

        setTimeout(() => {
          this.$refs.$tip.innerHTML = ''
        }, 200)
      }
    },

    _scrollFullBannerY(element, pos, flag) {
      if (pos > this.fullBannerMaxY) {
        pos = this.fullBannerMaxY
      }

      if (pos < this.fullBannerMinY) {
        pos = this.fullBannerMinY
      }

      if (flag) {
        element.style.transition = '.2s all'
      } else {
        element.style.transition = null
      }

      element.style.transform = 'translate3d(0, ' + pos + 'px, 0)'
      element.curPos = pos
    },

    _grow(element, size, flag) {
      if (size < this.fullBannerMaxY) {
        size = this.fullBannerMaxY
      }

      if (size > -this.fullBannerMinY) {
        size = -this.fullBannerMinY
      }

      window.requestAnimationFrame(() => {
        element.style.height = size + 'px'
      })

      if (flag) {
        element.style.transition = '.2s all'
      } else {
        element.style.transition = null
      }

      element.size = size
    },

    _initFullBanner() {
      if (this.timer) {
        clearInterval(this.timer)
      }

      this.displayCyliveBanner = false

      this.$nextTick(() => {
        this._scrollFullBannerY(this.$refs.$fullBanner, this.fullBannerMinY)
        this._grow(this.$refs.$space, 0)
        this._initInteraction()
      })
    },

    _go(e) {
      window.spm.push([ '_trackEvent', '101587', '02', '200' ])

      const url = this.liveUrl

      if (url.match('cylive')) {
        location.replace(url.split('#')[0] + '?channel_source=02005831')
      } else {
        location.replace(url)
      }
    },

    _initNoticeMarquee() {

      const $wrapper = document.querySelector('.notice')
      const $inner = $wrapper.querySelector('div')
      const fixWidth = $wrapper.offsetWidth - $inner.offsetWidth
      const $a = $inner.querySelector('span:nth-of-type(1)')
      const $b = $inner.querySelector('span:nth-of-type(2)')

      if ($a.offsetWidth + fixWidth > $wrapper.offsetWidth) {
        $a.style.paddingRight = '1.6rem'

        const marquee = (timestamp, elapsed) => {
          if (elapsed > 1000 / 30) {
            $inner.scrollLeft += 1

            if ($inner.scrollLeft === $a.offsetWidth) {
              $inner.scrollLeft = 0
            }

            elapsed = 0
          }

          window.requestAnimationFrame(_timestamp => marquee(_timestamp, elapsed + _timestamp - timestamp))
        }

        window.requestAnimationFrame(timestamp => marquee(timestamp, 0))
      } else {
        $inner.removeChild($b)
      }

      this.$inner = $inner
    },

    async _initBanner() {
      const res = await reqCyRecommendation({
        keyId: 'H5_310_spzbgg'
      })

      if (res) {
        this.isApiDataLoaded()

        if (!sessionStorage.getItem('CHANGYO_HOME_LIVE_BANNER_CLOSED') && res.data.H5_310_spzbgg[0]) {
          this.displayCyliveBanner = true
          this.displayBtnForClosing = true
          this.banner = server.imgUrl + '/' + res.data.H5_310_spzbgg[0].adContent
          this.liveUrl = res.data.H5_310_spzbgg[0].adUrl

          cookie.set('CHANGYOU_LIVE_BANNER_URL', this.liveUrl)

          const step = 1000

          this.timer = setInterval(() => {
            if (this.count <= 1) {
              clearInterval(this.timer)
              this.closeBanner()
            } else {
              --this.count
            }
          }, step)
        } else {
          this.closeBanner()
        }
      }
    },

    async _initBanner2() {
      const res = await reqCyQueryAdvert({
        appId: 'Changyoyo_Life_Central',
        featuredFirstCode: 'H5_new_CYJFGG',
        channel: 'Changyoyo_Life_Central',
        pageNum: 1,
        pageSize: 10
      }).catch(err=> {console.log(err)})
      console.log('dzq',res)

      if (res && res.data && res.data.advertiseOnlines && res.data.advertiseOnlines.length > 0) {
        const info = res.data.advertiseOnlines[0]

        this.banner2 = server.imgUrl + '/' + info.advertiseViewImg
        this.notice = info.remark
        // this.displayFullBanner = true

        this.$nextTick(() => {
          this._initNoticeMarquee()

          if (!info.advertiseViewImg) {
            window.ontouchstart = null
            this.$scrollEl.ontouchmove = null
            window.ontouchend = null
          }
        })
      }
    },

    closeBanner() {
      window.spm.push([ '_trackEvent', '101588', '02', '200' ])

      this.$refs.$banner.style.transition = '.4s all'
      this.$refs.$banner.style.marginTop = -this.$refs.$banner.offsetHeight + 'px'
      this.displayBtnForClosing = false

      // 记录广告关闭状态
      sessionStorage.setItem('CHANGYO_HOME_LIVE_BANNER_CLOSED', true)

      setTimeout(() => {
        this._initBanner2()
        this._initFullBanner()
        this.displayWinMask = false
      }, 450)
    }
  }
}
